import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/roadmap" element={<HomePage />} />
          <Route path="/about" element={<HomePage />} />
          <Route path="/how-to-buy" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
      {/* Noise overlay for gritty texture */}
      <div className="noise-overlay" />
    </div>
  );
}

export default App;
